/**
 * API URL utility - resolves the correct backend URL at runtime.
 * In production, uses the current origin (same domain) instead of
 * potentially stale REACT_APP_BACKEND_URL build-time value.
 */
const configuredUrl = process.env.REACT_APP_BACKEND_URL || '';

function getApiUrl() {
  // In production (served from restainpace.it or emergent.host), use same-origin
  const hostname = window.location.hostname;
  if (hostname === 'restainpace.it' || hostname === 'www.restainpace.it' || hostname.endsWith('.emergent.host')) {
    return window.location.origin;
  }
  // In preview/development, use the configured URL
  return configuredUrl;
}

export const API_URL = getApiUrl();
export default API_URL;
